import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ListGroupItem } from 'reactstrap';
import { PermissionName } from '../../shared/permissions';
import { ActionType } from '../services';
import { TranslationKey, useTranslation } from '../translations';
import { checkPermission, useUser } from '../utils';
import { AutoLink } from './AutoLink';
import { MaterialIcon } from './MaterialIcon';

interface SidenavItemProps {
  readonly id?: string;
  readonly link?: string;
  readonly text?: TranslationKey;
  readonly icon?: string;
  readonly header?: boolean;
  readonly requiredPermissions?: PermissionName | PermissionName[];
  readonly matchAny?: boolean;
  readonly matchUrlPrefix?: boolean;
  readonly requireLoggedIn?: boolean;
  readonly newTab?: boolean;
}

export const SidenavItem: FC<SidenavItemProps> = ({
  requiredPermissions,
  requireLoggedIn,
  text,
  link,
  id,
  icon,
  header,
  matchAny,
  newTab,
  matchUrlPrefix = false,
}) => {
  const user = useUser();
  const { ts } = useTranslation();

  const dispatch = useDispatch();
  const sideNavClicked = useCallback(
    () => dispatch({ type: ActionType.SideNavLinkClicked }),
    [dispatch],
  );

  if (!user && (requireLoggedIn || requiredPermissions)) {
    return null;
  }

  if (requiredPermissions && user && !checkPermission(user, requiredPermissions, matchAny)) {
    return null;
  }

  if (text) {
    if (link) {
      return (
        <ListGroupItem id={id}>
          <AutoLink
            link={link}
            matchUrlPrefix={!matchUrlPrefix}
            newTab={!!newTab}
            onClick={sideNavClicked}
          >
            {icon && <MaterialIcon name={icon} />}
            <div>{ts(text)}</div>
          </AutoLink>
        </ListGroupItem>
      );
    }

    if (header) {
      return <ListGroupItem className="sidenav-header">{ts(text)}</ListGroupItem>;
    }
  }

  return <ListGroupItem className="sidenav-spacer" />;
};
